import React, { FC } from 'react';
import { ModalOverlay } from '@moda/om';
import { Authentication } from '../Authentication';
import { useAuthModal } from '../../../hooks/useAuthModal';

export const AuthenticationModal: FC = () => {
  const { show, closeAuthModal, handleAuthSuccess } = useAuthModal();

  return (
    <ModalOverlay data-testid="authentication-modal" onClose={closeAuthModal} show={show}>
      <Authentication onAuth={handleAuthSuccess} modal />
    </ModalOverlay>
  );
};
